import { useEffect } from "react";
import { Route, Routes } from "react-router-dom";
import { setDocumentTitle } from "@/lib/documentTitle";

import { C7PositionsEdit } from "./edit";
import { C7PositionsNew } from "./new";
import { C7PositionsTable } from "./table";

export default function C7Positions() {
  useEffect(() => {
    setDocumentTitle("Quantilia | Positions");
  }, []);

  return (
    <Routes>
      <Route path="new" element={<C7PositionsNew />} />
      <Route path=":id" element={<C7PositionsEdit />} />
      <Route index element={<C7PositionsTable />} />
    </Routes>
  );
}
